// Types
export type {
  AnalyticsService,
  IdentityService,
  EventService,
  FeatureFlagService,
  ConsentService,
  ServerAnalyticsService,
  AnalyticsUser,
} from './types';

// Event catalog
export { AnalyticsEvents } from './events';
export type {
  AnalyticsEventName,
  AuthEventProperties,
  OrderEventProperties,
  PaymentEventProperties,
  TeamEventProperties,
  ErrorEventProperties,
} from './events';

// Client implementation
export { analytics, identifyUser } from './posthog-client';

// Consent
export { getConsentStatus, setConsentStatus } from './consent';
export type { ConsentStatus } from './consent';
